import { Route } from 'react-router-dom';
import { ExperienceReservationList } from './list';

export const ExperienceReservationsRoute = (
  <Route path="reservations">
    <Route index element={<ExperienceReservationList />} />
    <Route path=":id" element={<ExperienceReservationList />} />
  </Route>
);
